import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export default function ActionBar({
  className,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  isEditDisabled = true
}: ActionBarProps) {
  return (
    <AritoActionBar titleComponent={<h1 className='text-xl font-bold'>Bút toán hủy/đảo</h1>}>
      <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAdd} />
      <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} disabled={isEditDisabled} />
      <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} disabled={isEditDisabled} />
      <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} disabled={isEditDisabled} />
      <AritoActionButton title='In ấn' icon={PrinterStroke} onClick={onPrint} />
      <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearch} />

      <AritoMenuButton
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 3
          }
        ]}
      />
    </AritoActionBar>
  );
}
